export default __webpack_public_path__ + "static/media/s5.07026c3c.jpg";